var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',[_c('q-card-section'),_c('q-card-actions',[_c('q-btn',{attrs:{"label":"شروع اسکن","color":"primary"},on:{"click":_vm.startScan}}),_c('q-btn',{attrs:{"label":"انصراف از اسکن","color":"red","flat":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }